import { api } from "@/lib/api";
import {
  AccommodationDto,
  AccommodationDtoListSchema,
  accommodationFromDto,
  AccommodationWithFulfillmentsDto,
  AccommodationWithFulfillmentsDtoListSchema,
  accommodationWithFulfillmentsFromDto,
} from "@/models";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

export function getAccommodationQueryOptions(reservationId: string) {
  return queryOptions({
    queryKey: ["accommodations", reservationId],
    queryFn: async () => {
      const result: Array<AccommodationDto> = [];
      let page = 0;
      let hasNextPage = true;
      while (hasNextPage) {
        page += 1;
        const res = await api.getWithCache(
          "/api/accommodations",
          AccommodationDtoListSchema,
          {
            query: {
              page: page.toString(),
            },
            filters: {
              ReservationId: Number.parseInt(reservationId),
            },
            projection: ["AccommodationReservationClients"],
          },
        );
        result.push(...res.Data);
        hasNextPage = res.PageInfo.HasNextPage;
      }
      return result.map(accommodationFromDto);
    },
  });
}

export function useGetAccommodations(reservationId: string) {
  return useQuery({
    ...getAccommodationQueryOptions(reservationId),
  });
}

export function getAccommodationWithFulfillmentsQueryOptions(
  reservationId: string,
) {
  return queryOptions({
    queryKey: ["accommodations-fulfillments", reservationId],
    queryFn: async () => {
      const result: Array<AccommodationWithFulfillmentsDto> = [];
      let page = 0;
      let hasNextPage = true;
      while (hasNextPage) {
        page += 1;
        const res = await api.getWithCache(
          "/api/accommodations",
          AccommodationWithFulfillmentsDtoListSchema,
          {
            query: {
              page: page.toString(),
            },
            filters: {
              ReservationId: Number.parseInt(reservationId),
            },
            projection: [
              "FulfillmentAccommodations.Fulfillment",
              "HotelRoom.Hotel",
            ],
          },
        );
        result.push(...res.Data);
        hasNextPage = res.PageInfo.HasNextPage;
      }
      return result.map(accommodationWithFulfillmentsFromDto);
    },
  });
}

export function useGetAccommodationsWithFulfillments(reservationId: string) {
  const q = useQuery({
    ...getAccommodationWithFulfillmentsQueryOptions(reservationId),
  });
  useEffect(() => {
    if (!q.error) return;
    console.error(q.error);
  }, [q.error]);
  return q;
}
